import type { IFirestoreEntity, IMetadata } from '@common/types';

export const transformMetadata = <T extends IFirestoreEntity>(
  metadata: T['metadata'],
): T['metadata'] => {
  if (!metadata) return undefined as unknown as T['metadata'];

  return {
    ...metadata,
    createdAt: metadata.createdAt?.toDate(),
    updatedAt: metadata.updatedAt?.toDate(),
  } as T['metadata'];
};

export const getTime = (metadata: IMetadata) =>
  new Date(metadata.updatedAt as unknown as Date).getTime();
